"use client";

import styles from "./ForgotPasswordPageHeader.module.scss";

import { WEBSITE_URL } from "@/constants";
import { withLocale } from "@/helpers";
import { useTranslations, useLocale } from "@/i18n";
import { Flex } from "@vetty/ui";
import { Link } from "react-router-dom";

/**
 * ForgotPasswordPageHeader Component
 *
 * Navigation header for forgot password page with logo and menu links.
 * Provides branding and navigation options for password reset flow.
 */
export const ForgotPasswordPageHeader = () => {
  const t = useTranslations("forgotPassword.header");
  const locale = useLocale();

  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      {/* Company logo - links to main website */}
      <a href={`${WEBSITE_URL}/${locale}`} className={styles["comp__logo-link"]}>
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      {/* Navigation menu */}
      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        {/* Contact sales link */}
        <a
          href={`${WEBSITE_URL}/${locale}/university#contact-sales`}
          className={styles["comp__menu__item"]}
        >
          {t("contactSales")}
        </a>

        <Link
          to={withLocale(locale, "/login")}
          className={styles["comp__menu__item"]}
        >
          {t("logIn")}
        </Link>
      </Flex>
    </Flex>
  );
};
